import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Accordion } from '@sainsburys-tech/bolt'
import { InView } from 'react-intersection-observer'
import noop from 'lodash.noop'
import SpecialOffer from '../SpecialOffersAccordion/SpecialOffer'
import Bundle from '../Bundles/Bundle'
import CountBadge from '../CountBadge/CountBadge'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'
import { scrollToAccordion } from '../../helpers/openAccordion'
import { trackBundleInView } from '../../templates/EventTrackers'

import * as Styled from './GenericAccordion.styles'

class GenericAccordion extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadContent: false,
      hasBundleBlockBeenViewed: false
    }
  }

  trackAccordionInteraction = (index, show, idElement, eventActionText, type) => {
    this.props.onAccordionChange(type, show)

    if (show) scrollToAccordion(idElement)
    // Adobe Analytics Tracking Code
    const adobeAnalytics = show ? pushEventAndTrack : noop
    adobeAnalytics({
      eventInfo: {
        eventName: 'pdp_showMore',
        eventAction: eventActionText
      }
    })
  }

  buildDataObject = () => {
    const { bundles, partNumber, price, productName, offers, type } = this.props
    switch (type) {
      case 'bundles':
        return {
          id: 'frequently-bought-together-accordion',
          title: 'Frequently bought together',
          elements: bundles.map((bundle, index) => {
            const bundleId = bundle.id
            const { items } = bundle.attributes
            return <Bundle key={index} {...{ bundleId, items, partNumber, price, productName, index }} />
          })
        }

      case 'offers':
        return {
          id: 'special-offers-accordion',
          title: 'Special offers',
          elements:
            (offers?.length &&
              offers.map(offer => <SpecialOffer offer={offer} currentProduct={partNumber} key={offer.id} />)) ||
            []
        }

      default:
        return null
    }
  }

  createBundleAnalyticsOptions = () => {
    const { bundles, partNumber, price, productName } = this.props
    return {
      bundles: bundles.map((bundle, index) => {
        const { items } = bundle.attributes

        return {
          bundleId: bundle.id,
          bundleItems: {
            main: {
              id: partNumber,
              price: price && price.now,
              quantity: 1,
              name: productName
            },
            additional: items.map(item => ({
              id: item.id,
              price: item.price,
              quantity: 1,
              name: item.name
            }))
          },
          bundleType: 'fbtBundle',
          bundleSize: items.length + 1,
          bundlePlacement: `P${index + 1}`
        }
      })
    }
  }

  onView = () => {
    if (this.props.type === 'bundles') {
      const isOpened =
        document.querySelector('#frequently-bought-together-accordion button').attributes['aria-expanded'].value ===
        'true'

      if (!isOpened || this.state.hasBundleBlockBeenViewed) return

      trackBundleInView(this.createBundleAnalyticsOptions())
    }
    this.setState({ hasBundleBlockBeenViewed: true })
  }

  render() {
    const { type, partNumber } = this.props

    const data = this.buildDataObject()
    if (!data || !data.elements.length) return null

    const maxDisplayOffer = 6
    const Rows = data.elements.slice(0, maxDisplayOffer)

    const previewContent = (
      <Styled.Header className='generic-accordion__header'>
        <Styled.Title>{data.title}</Styled.Title> <CountBadge items={data.elements.length} isFlag={false} type={type} />
      </Styled.Header>
    )

    const hiddenContent = (
      <InView as='div' triggerOnce onChange={this.onView} threshold={0.2}>
        <Styled.Accordion className=''>{Rows}</Styled.Accordion>
      </InView>
    )

    const isTuBundles = partNumber.startsWith('tuc') && type === 'bundles'

    const accordionOptions = {
      title: previewContent,
      name: `${type}-accordion`,
      onClick: (index, show) => this.trackAccordionInteraction(index, show, `#${data.id}`, data.title, type),
      'data-test': `${type}-accordion`,
      index: `${type}-accordion`,
      isOpen: isTuBundles
    }

    return (
      <Styled.Accordion className='generic-accordion' id={data.id}>
        <Accordion.Item as='h3' hasBorderBottom {...accordionOptions} noAnimation>
          <InView
            as='div'
            triggerOnce
            rootMargin='0px 0px 500px 0px'
            onChange={inView => inView && this.setState({ loadContent: true })}
          >
            {this.state.loadContent && hiddenContent}
          </InView>
        </Accordion.Item>
      </Styled.Accordion>
    )
  }
}
GenericAccordion.propTypes = {
  bundles: PropTypes.arrayOf(PropTypes.object).isRequired,
  type: PropTypes.string.isRequired,
  partNumber: PropTypes.string.isRequired,
  price: PropTypes.object.isRequired,
  productName: PropTypes.string.isRequired,
  onAccordionChange: PropTypes.func.isRequired
}

export default GenericAccordion
